export const COMPRA_STATUS_ABERTO = 1
export const COMPRA_STATUS_RECEBIDO = 6
export const COMPRA_STATUS_INFO_ENVIADA = 7
export const PEDIDO_COMPRA_STATUS_CONTRATADO = 3
export const PEDIDO_COMPRA_STATUS_APROVADO = 5
export const PEDIDO_COMPRA_TP_PADRAO = 2
export const PEDIDO_COMPRA_TP_RAPIDA = 3
export const PEDIDO_COMPRA_TP_ADESAO = 4

export const PEDIDO_COMPRA_COM_CONTRATO_OPTIONS = [
  { value: 1, label: 'Com contrato' },
  { value: 0, label: 'Sem contrato' },
]

export const isPedidoCompraComContrato = (pedidoCompra = {}) => (
  Number(pedidoCompra?.pedidoCompra_comContrato) === 1
)

export const getCompraCotacaoFields = () => ({
  "(SELECT orcItem_id FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = compraCotacao.pedidoCompra_id LIMIT 1) LIMIT 1)": "orcItem_id",
  "(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM pedidoCompra WHERE pedidoCompra.pedidoCompra_id = compraCotacao.pedidoCompra_id LIMIT 1) LIMIT 1) LIMIT 1)": "pf_emailProf",
  "(SELECT contrForn_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_id",
  "(SELECT contrForn_num FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_num",
  "(SELECT contrForn_desc FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_desc",
  "(SELECT contrForn_obj FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_obj",
  "(SELECT contrForn_detalhamento FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_detalhamento",
  "(SELECT contrForn_parteTab FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_parteTab",
  "(SELECT contrForn_parteId FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_parteId",
  "(SELECT contrForn_dtAssin FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_dtAssin",
  "(SELECT contrForn_dtVigIni FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_dtVigIni",
  "(SELECT contrForn_dtVigFim FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_dtVigFim",
  "(SELECT contrFornTp_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrFornTp_id",
  "(SELECT contrForn_vlrGlobal FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_vlrGlobal",
  "(SELECT contrForn_obs FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_obs",
  "(SELECT contrFornStatus_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrFornStatus_id",
  "(SELECT tpMinuta_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "tpMinuta_id",
  "(SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1)": "contrForn_orcItem_id",
  "(SELECT nivel2 FROM viewOrcRubr_taxonomia2 WHERE id_oikos = (SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "centroDeCusto",
  "(SELECT nivel2_id FROM viewRubr_OrcItem WHERE orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "centroDeCustoRubr_id",
  "(SELECT nivel3 FROM viewRubr_OrcItem WHERE orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "proj_nome",
  "(SELECT orcItem_desc FROM orcItem WHERE orcItem.orcItem_id = (SELECT orcItem_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "orcItem_desc",
  "(SELECT tpMinuta_nome FROM tpMinuta WHERE tpMinuta.tpMinuta_id = (SELECT tpMinuta_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "tpMinuta_nome",
  "(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT contrForn_parteId FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id AND contrForn.contrForn_parteTab = 'pf' LIMIT 1) LIMIT 1)": "contratado_nomePf",
  "(SELECT pj_razaosocial FROM pj WHERE pj.pj_id = (SELECT contrForn_parteId FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id AND contrForn.contrForn_parteTab = 'pj' LIMIT 1) LIMIT 1)": "contratado_nomePj",
  "(SELECT contrFornTp_nome FROM contrFornTp WHERE contrFornTp.contrFornTp_id = (SELECT contrFornTp_id FROM contrForn WHERE contrForn.compraCotacao_id = compraCotacao.compraCotacao_id LIMIT 1) LIMIT 1)": "contrFornTp_nome",
  "(SELECT CASE WHEN ROUND(COALESCE(SUM(cfe.contrFornEvento_vlr), 0), 2) = ROUND(COALESCE(cf.contrForn_vlrGlobal, 0), 2) THEN 1 ELSE 0 END FROM contrForn cf LEFT JOIN contrFornEvento cfe ON cfe.contrForn_id = cf.contrForn_id WHERE cf.compraCotacao_id = compraCotacao.compraCotacao_id GROUP BY cf.contrForn_id, cf.contrForn_vlrGlobal LIMIT 1)": "contrForn_parcelas_batem_vlrGlobal",
  "(SELECT compraStatus_nome FROM compraStatus WHERE compraStatus.compraStatus_id = compraCotacao.compraStatus_id LIMIT 1)": "compraStatus_nome",
  "(SELECT a.arquivo_caminho FROM arquivo a INNER JOIN documento d ON a.arquivo_tabId = d.documento_id AND a.arquivo_tabRef = 'documento' INNER JOIN documentoVinc dv ON dv.documento_id = d.documento_id WHERE dv.documentoVinc_tabRef = 'compraCotacao' AND dv.documentoVinc_tabId = compraCotacao.compraCotacao_id AND d.tpDocumento_id = 37 AND COALESCE(d.documento_ativo, 1) = 1 AND COALESCE(a.arquivo_ativo, 1) = 1 AND COALESCE(dv.documentoVinc_ativo, 1) = 1 ORDER BY a.arquivo_id DESC LIMIT 1)": "compraCotacao_anexo_caminho",
})

export const pedidoCompraTemCotacaoContratada = (compraCotacoes = []) => (
  compraCotacoes.some((cotacao) => [2, 3].includes(Number(cotacao.compraStatus_id)))
)

export const pedidoCompraTemContratacaoEmAndamento = (
  compraCotacoes = [],
  { excludeCompraCotacaoId } = {},
) => (
  compraCotacoes.some((cotacao) => {
    if (
      excludeCompraCotacaoId
      && Number(cotacao.compraCotacao_id) === Number(excludeCompraCotacaoId)
    ) {
      return false;
    }

    return [COMPRA_STATUS_INFO_ENVIADA, COMPRA_STATUS_RECEBIDO, 8].includes(
      Number(cotacao.compraStatus_id),
    );
  })
)

export const pedidoCompraTemOrcItemVinculado = (pedidoCompra, compraCotacao) => Boolean(
  Number(pedidoCompra?.orcItem_id)
  || Number(compraCotacao?.orcItem_id)
  || Number(compraCotacao?.contrForn_orcItem_id),
)

export const compraCotacaoContrFornHideProps = {
  hideTipoContratado: true,
  hideContratado: true,
  hideContratoValorFixoOpcao: true,
  hideContratoDiaFixoPagamentoOpcao: true,
  hideContratoRenovacaoAutomaticaOpcao: true,
  hideContratoNfUnicaOpcao: true,
  hideContratoMaoObraLocalOpcao: true,
  hideObservacao: true,
  hideDocumentoContrato: true,
  hideContratoObjeto: true,
  hideContratoDetalhamento: true,
  showContratante: true,
  showDocumentosObrigatorios: true,
  hideParcelasOrcamentoTable: true,
  hideParcelasTable: true,
}

/** Cotação padrão (tp 2): mesma base, mas exibe Tipo de contratado + Contratado (como cadastro standalone). */
export const compraCotacaoContrFornHidePropsComContratado = {
  ...compraCotacaoContrFornHideProps,
  hideTipoContratado: false,
  hideContratado: false,
}

export const mrtTopToolbarProps = {
  sx: {
    '.MuiBox-root': { marginTop: '10px', height: '20px', display: 'flex', alignItems: 'center' },
    '.MuiSvgIcon-root': { width: '12px' },
    '.MuiButtonBase-root': { padding: '5px 5px 5px 5px' },
  },
}

export const mrtHeadCellProps = {
  sx: {
    '.MuiSvgIcon-root': { fontSize: '18px' },
    fontSize: '12px',
    fontWeight: 'normal',
    padding: '8px',
  },
}
